import "./Footer.css"
import "./Tile.css"

const Tile = ({
    title, subtitle
}) => {
    return (
        <div className="Tile-wrapper">
            <span className="Tile-title">{title}</span>
            <span className="Tile-subtitle">{subtitle}</span>
        </div>
    )
}

export default function Footer() {
    return (
        <div id="App-footer">
            <div id="App-footer-highlights">
                {/* <Tile title="michael black" subtitle="Director Ejecutivo" /> */}
                <Tile title="email" subtitle="michael@joygroup.io" />
                {/* <Tile title="telefono" subtitle="+56 9 9537 3017" /> */}
                <Tile title="cobertura" subtitle="Chile | Argentina | LATAM" />
                <Tile title="redes" subtitle={(
                    <a href="https://www.linkedin.com/company/joy-sports-joy-group" target="_blank" rel="noopener noreferrer">
                        <svg
                            id="linkedin-button"
                            width={24}
                            height={24}
                            viewBox="0 0 24 24"
                            className="linkedin-icon"
                        >
                            <path d="M4.98 3.5C4.98 4.88 3.87 6 2.5 6S0 4.88 0 3.5 1.12 1 2.5 1 4.98 2.12 4.98 3.5zM.06 8h4.88v16H.06V8zm7.57 0h4.68v2.23h.07c.65-1.23 2.24-2.52 4.6-2.52 4.92 0 5.82 3.24 5.82 7.46v8.83h-4.88v-7.81c0-1.86-.03-4.25-2.59-4.25-2.59 0-2.99 2.03-2.99 4.12v7.94H7.63V8z" />
                        </svg>
                    </a>
                )} />
            </div>
            <div id="App-footer-disclaimer-wrapper">
                <span>JoySports es una empresa de <a href="https://joygroup.io"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: "#4da3ff", textDecoration: "none" }}>
                    Joy Group
                </a>. Todos los derechos reservados 2025</span>
            </div>
        </div>
    )
}